<div class="nb-page-header">
  <div>
    <!--    <button nz-button nzType="text" (click)="goBack()"><i nz-icon nzType="left" nzTheme="outline"></i>返回</button>-->
    <span class="title">{{ node?.processTitle }}</span>
  </div>
  <!--  <div>-->
  <!--    <button nz-button *ngFor="let op of edges" [nzType]="op.type" (click)="popSubmitTask(op)">{{ op.name }}</button>-->
  <!--  </div>-->
</div>
<div class="full-panel equal-height">
  <!--  <div class="right-panel">-->
  <nz-card class="container" style="width: 76%; margin-right: 10px">
    <nz-card-tab>
      <nz-tabset *ngIf="forms" [(nzSelectedIndex)]="index" (nzSelectedIndexChange)="changeIndex($event)">
        <nz-tab *ngFor="let t of forms" [nzTitle]="t.displayName"></nz-tab>
      </nz-tabset>
    </nz-card-tab>
    <div class="apply-info-content">
      <nb-form-viewer
        [formGroup]="currentGroup"
        [form]="currentForm"
        [data]="currentData"
        [downloadUrl]="downloadUrl"
        [uploadUrl]="uploadUrl"
        [importUrl]="importUrl"
        [token]="token"
        [pdfUrl]="pdfUrl"
      ></nb-form-viewer>
    </div>
  </nz-card>
  <!--  </div>-->

  <div class="left-panel">
    <h1 class="title">发起申请</h1>
    <div class="audit-tip-box">
      <!--      <div class="audit-tip">未提交</div>-->
    </div>

    <nz-card nzBorderless nzSize="small" class="indicator-card" nzTitle="抄送信息">
      <div class="make-copy-frame">
        <div class="copy-each" (click)="popAddCcUser()">
          <div class="copy-img-box" style="cursor: pointer">
            <div class="bg-img">
              <img class="copy-img" src="../../../../assets/picture/add.png" alt=" " />
            </div>
          </div>
        </div>

        <div class="copy-each" *ngFor="let op of ccUsers">
          <div class="copy-img-box">
            <div class="bg-img">
              <img
                class="copy-img"
                [src]="staffMap[op] && staffMap[op].avatar ? downLoad + staffMap[op].avatar : '../../../../assets/picture/init-img.png'"
              />
            </div>
            <!--            <div class='del-icon'>x</div>-->
          </div>
          <div>{{ staffMap[op] ? staffMap[op].name : '-' }}</div>
        </div>
      </div>
      <div class="nb-divider"></div>
    </nz-card>

    <!--    <nz-card nzBorderless nzSize='small' class='indicator-card' nzTitle='抄送信息'>-->
    <!--      <nz-descriptions nzSize='small' nzBordered [nzColumn]='1'>-->
    <!--        <nz-descriptions-item nzTitle='抄送职能'>-->
    <!--          <nz-tag *ngFor='let op of node?.processCcRoles'-->
    <!--                  [nzColor]="'blue'">{{roleMap[op] ? roleMap[op].name : '-'}}</nz-tag>-->
    <!--        </nz-descriptions-item>-->
    <!--        <nz-descriptions-item nzTitle='抄送员工'>-->
    <!--          <nz-tag *ngFor='let op of node?.processCcUsers'-->
    <!--                  [nzColor]="'purple'">{{staffMap[op] ? staffMap[op].name : '-'}}</nz-tag>-->
    <!--        </nz-descriptions-item>-->
    <!--        <nz-descriptions-item nzTitle='追加抄送'>-->
    <!--          <nz-tag *ngFor='let op of ccUsers' [nzColor]="'volcano'">{{staffMap[op] ? staffMap[op].name : '-'}}</nz-tag>-->
    <!--          <button nz-button nzType='primary' nzShape='circle' (click)='popAddCcUser()'><i nz-icon nzType='edit'></i>-->
    <!--          </button>-->
    <!--        </nz-descriptions-item>-->
    <!--      </nz-descriptions>-->
    <!--      <div class='nb-divider'></div>-->
    <!--    </nz-card>-->

    <!--    <nz-card nzBorderless nzSize='small' class='indicator-card' nzTitle='提交说明'>-->
    <!--      <textarea nz-input placeholder='请输入内容' [nzAutosize]='{ minRows: 3, maxRows: 5 }'></textarea>-->
    <!--    </nz-card>-->
    <div style="display: flex; justify-content: space-around">
      <button
        style="min-width: 25%"
        nz-button
        *ngFor="let op of edges"
        [nzType]="op.type"
        (click)="popSubmitTask(op)"
        [nzLoading]="loadingSubmit"
      >
        {{ op.name }}
      </button>
      <button style="min-width: 25%; background-color: #00c56c; color: #ffffff" nz-button (click)="saveDraft()" [nzLoading]="loadingSave">
        保存草稿
      </button>
    </div>
  </div>
</div>

<nz-modal [(nzVisible)]="showCcModal" nzTitle="追加抄送对象" (nzOnCancel)="showCcModal = false" (nzOnOk)="confirmCC()">
  <ng-container *nzModalContent>
    <div nz-row [nzGutter]="24">
      <nz-form-label nz-col nzRequired [nzSpan]="4">员工</nz-form-label>
      <nz-form-control nz-col [nzSpan]="20">
        <nz-select style="width: 100%" [(ngModel)]="ccUserPop" nzMode="multiple" nzAllowClear nzShowSearch>
          <nz-option *ngFor="let op of staffs" [nzLabel]="op.name" [nzValue]="op.id"></nz-option>
        </nz-select>
      </nz-form-control>
    </div>
  </ng-container>
</nz-modal>
